// ── Firmware update steps (shared between Config and Network update flows) ──
export const FIRMWARE_UPDATE_STEPS = [
  "Establishing connection",
  "Verifying firmware package",
  "Erasing flash memory",
  "Writing firmware",
  "Verifying installation",
  "Restarting device",
];

// ── Firmware catalog ────────────────────────────────────────────────────────
// Add an entry here whenever a new update becomes available for a node.
// Key = node ID as returned by discoverMockNetwork().
export const FIRMWARE_CATALOG = {
  "bms-bridge": {
    nodeId: "bms-bridge",
    nodeName: "cBerry BMS Bridge",
    currentVersion: "v2.5.1",
    availableVersion: "v2.6.0",
    releaseDate: "2025-04-12",
    changelog: [
      {
        version: "v2.6.0",
        date: "2025-04-12",
        highlights: [
          "Improved SoC estimation — accuracy raised from ±3 % to ±1 %",
          "Enhanced low-temperature charging protection (safe operation from −20 °C)",
          "Extended CAN diagnostics: additional fault codes and freeze-frame capture",
          "Reduced deep-sleep current draw by 18 % (220 µA → 180 µA)",
          "New per-cell over-voltage soft protection with configurable threshold",
        ],
        fixes: [
          "Fixed cell-balancing timeout when load current exceeded 80 A",
          "Resolved occasional BLE disconnect after continuous operation > 24 h",
          "Corrected voltage reading drift at temperatures below 0 °C",
          "Fixed SoH calculation drifting after a partial charge cycle",
          "Resolved CAN bus lockup when two nodes broadcast simultaneously",
        ],
        notes:
          "After updating, the device will restart and recalibrate SoC. " +
          "Recalibration takes approximately 30 s. No historical data is lost.",
      },
      {
        version: "v2.5.1",
        date: "2024-12-03",
        highlights: [
          "Stability improvements for BLE pairing on Android 14+",
          "Faster CAN bus re-join after vehicle power cycle",
        ],
        fixes: [
          "Fixed crash on rapid connect / disconnect cycles",
          "Corrected display of negative power values in CAN telemetry frame",
        ],
        notes: "",
      },
    ],
  },
};

// Returns entries from the catalog that have not yet been installed.
// Pass `updatedFirmware` from app state (map of nodeId → { version, updatedAt }).
export function getAvailableUpdates(updatedFirmware = {}) {
  return Object.values(FIRMWARE_CATALOG).filter(
    (entry) => !updatedFirmware[entry.nodeId]
  );
}
